import React from 'react'

const LoginButton = ({onClick}) => (
  <button onClick={onClick} className="login__button">Sign In</button>
)

export default LoginButton



// WEBPACK FOOTER //
// ./src/components/LoginWidget/LoginButton/index.js